import { Device } from 'DeviceUtils';
import { t } from 'Locale';
import React, { useEffect } from 'react';
import { BackHandler, Linking, Text, View } from 'react-native';
import { Button, Hr, Icon } from 'LocalGluons';
import { fontStyles, globalStyles } from 'Theme';
import styles from './ForceUpdate.jss';

import PLATFORM_INFO from '../../../../platformAssets/renative.runtime.json';

const ForceUpdate: React.FC = () => {
    const handleBack = () => {
        return true;
    };

    const handleDeepLinking = async () => {
        const link = Device.isAndroid
            ? PLATFORM_INFO.meta.googleplayUrl.replace(
                  'https://play.google.com/store/apps/',
                  'market://'
              )
            : PLATFORM_INFO.meta.appstoreUrl.replace('https', 'itms-apps');

        await Linking.openURL(link);
    };

    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', handleBack);

        return () => {
            BackHandler.removeEventListener('hardwareBackPress', handleBack);
        };
    }, []);

    return (
        <View style={styles.container}>
            <View style={styles.innerContainer}>
                <View style={styles.textContainer}>
                    <Icon name="warning_yellow" style={styles.infoIcon} />
                    <Text style={[fontStyles.title, styles.title]}>
                        {t('COMMON.APP_UPDATE_AVAILABLE_TITLE_MOBILES')}
                    </Text>
                </View>
                <Hr style={styles.hr} />
                <Text style={globalStyles.secondaryDescription}>
                    {t('COMMON.APP_UPDATE_AVAILABLE_DESCRIPTION_MOBILES')}
                </Text>
                <Button
                    style={{ button: styles.button }}
                    title={t('COMMON.APP_UPDATE_BTN_MOBILES')}
                    onPress={handleDeepLinking}
                />
            </View>
        </View>
    );
};

export default ForceUpdate;
